var _templateObject;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled from 'styled-components';
import { getSpacingSelector } from '@signal/theme/selectors';
import { CONSTRAINED_PAGE_MAX_WIDTH } from '../constants';
var gutterSpacingSelector = getSpacingSelector(3);
export var Wrapper = styled(function (_ref) {
  var disableGutter = _ref.disableGutter,
      constrainWidth = _ref.constrainWidth,
      rest = _objectWithoutProperties(_ref, ["disableGutter", "constrainWidth"]);

  return /*#__PURE__*/React.createElement("div", rest);
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  ", "\n  ", "\n"])), function (props) {
  return props.constrainWidth && "max-width: ".concat(CONSTRAINED_PAGE_MAX_WIDTH, ";");
}, function (props) {
  return !props.disableGutter && "padding: 0 ".concat(gutterSpacingSelector(props), "px;");
});